/* @flow */

import { rem } from 'polished';
import { baseFontSize } from '@braindate/ui/lib/token/typography';
import type { ThemeFunction } from 'src/shared/app/base/types/themeTypes';

export default {
  'root-isRegular': {
    borderRadius: 5,
    backgroundColor: ({ theme }: ThemeFunction) => theme.colorPrimary,
    border: ({ theme }: ThemeFunction) =>
      `solid 1px ${theme.textColorSecondary}`,
    padding: '0.5em',

    '&::placeholder': {
      color: '#747476',
      textAlign: 'center',
      fontSize: rem(16, baseFontSize),
      verticalAlign: 'middle',
      height: '100%',
      padding: [0, 25],
      fontStyle: 'normal',
      WebkitFontSmoothing: 'antialiased',
    },
  },
  'root-isHighlighted': {
    fontSize: 22,
    lineHeight: 1.1,
  },
  'root-hasError': {
    borderColor: ({ theme }: ThemeFunction) =>
      `${theme.errorMessageColor} !important`,
  },
};
